import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot } from 'lexical';
import { useImperativeHandle, forwardRef } from 'react';

export interface ClearPluginRef {
  clear: () => void;
}

export const ClearPlugin = forwardRef<ClearPluginRef>((_, ref) => {
  const [editor] = useLexicalComposerContext();

  useImperativeHandle(ref, () => ({
    clear: () => {
      editor.update(() => {
        const root = $getRoot();
        root.clear();
      });
    },
  }));

  return null;
});

ClearPlugin.displayName = 'ClearPlugin';
